import React, { useState, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import { Button } from 'admin/components/atoms/Buttons';
import CustomerFilter from 'admin/components/organisms/CustomerFilter';
import CustomerSelector from 'admin/components/organisms/CustomerSelector';
import { getMobilePushOperationCustomers, submitMobilePushOperation } from 'admin/actions/mobile-push-operations';
import ApiResults from 'admin/components/molecules/ApiResults';
import MessageComposeForm from './MessageComposeForm';
import _ from 'lodash';
import styled from 'styled-components';
import { useAppSelector } from '../../../hooks/useApp';
import { selectUserPrivateMoney } from '../../../reducers/user-private-money';

const crumb = [
  { value: 'ホーム', href: '/', active: false },
  { value: '販促管理', href: '', active: true },
  { value: 'プッシュメッセージ', href: '/promotion/mobile-push-operations', active: false },
  { value: '新規作成', href: '', active: true },
];

const normalizeDatetime = (value) => (
  value ? new Date(value).toISOString() : null
);

const Section = styled.div`
  margin: 15px auto;
`;

const Header = styled.div`
  font-weight: 600;
  margin: 4px auto;
`;

const MarginButton = styled(Button)`
  margin-right: 10px;
`;

const Label = styled.label`
  margin-right: 10px;
`;

const MobilePushOperationNewForm = ({ user, history, privateMoney, getMobilePushOperationCustomers, submitMobilePushOperation }) => {

  const userPrivateMoney = useAppSelector(selectUserPrivateMoney);

  const formMethods = useForm({
    mode: 'onChange',
    defaultValues: { target_rule: 'private-money' }
  });
  const { register, handleSubmit, setValue, formState } = formMethods
  const [isAllTarget, setIsAllTarget] = useState(true);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [query, setQuery] = useState('');
  const [apiMessages, setApiMessages] = useState(null);
  const selectedPrivateMoneyId = userPrivateMoney.id;

  useEffect(() => {
    setSelectedCustomerIds([]);
    getMobilePushOperationCustomers(
      null,
      `private_money_id=${selectedPrivateMoneyId}&page=1&account_status=active`
    ).then(setCustomers);
  }, [selectedPrivateMoneyId]);

  const onUpdateFilter = (queryParams) => {
    setQuery(queryParams);
    getMobilePushOperationCustomers(null, `${queryParams}&account_status=active`)
      .then(setCustomers);
  };

  const onUpdateCustomerCheckbox = (e) => {
    if (e.target.checked) {
      setSelectedCustomerIds(_.concat(selectedCustomerIds, e.target.value));
    }
    else {
      setSelectedCustomerIds(_.without(selectedCustomerIds, e.target.value));
    }
  };

  const onUpdateCustomerCheckAll = (isChecked) => {
    if (isChecked) {
      setSelectedCustomerIds(_.uniq(_.concat(selectedCustomerIds, customers.rows.map(c => c.id))));
    }
    else {
      setSelectedCustomerIds(_.difference(selectedCustomerIds, customers.rows.map(c => c.id)));
    }
  };

  const onChangeTargetRule = (e) => {
    setIsAllTarget(e.target.value === 'private-money');
  };

  const onChangePage = (page) => {
    const queryParams = query || `private_money_id=${selectedPrivateMoneyId}`;

    getMobilePushOperationCustomers(
      null,
      `${queryParams}&account_status=active&page=${page}`
    ).then(setCustomers);
  };

  const onSubmit = data => {
    const isAllTarget = data['target_rule'] === 'private-money';
    submitMobilePushOperation(_.pickBy(Object.assign({}, data, {
      scheduled_at: normalizeDatetime(data.scheduled_at),
      private_money_id: selectedPrivateMoneyId,
      user_ids: isAllTarget ? [] : selectedCustomerIds,
    }), v => !_.isNull(v))).then(response => {
      history.push('/promotion/mobile-push-operations');
    }).catch((err) => {
      err.then((res) => {
        setApiMessages([{ text: res.message, isError: true }]);
        setTimeout(() => setApiMessages(null), 3000);
      });
    });
  };

  return (
    <div>
      <Breadcrumb items={crumb} />

      <Section>
        <Header>プッシュメッセージ新規作成</Header>
        <FormProvider {...formMethods}>
          <MessageComposeForm />
        </FormProvider>
      </Section>

      <Section>
        <Header>配信先の設定</Header>
        <div>
          <Label>
            <input
              type="radio"
              {...register('target_rule')}
              value="private-money"
              onChange={onChangeTargetRule} /> 全員
          </Label>
          <Label>
            <input
              type="radio"
              {...register('target_rule')}
              value="none"
              onChange={onChangeTargetRule} /> 一部のお客様を選択
          </Label>
        </div>
        {isAllTarget
          ? null
          : (<>
              <CustomerFilter onFilterSubmit={onUpdateFilter} isMoneySelected={true} privateMoneyId={selectedPrivateMoneyId} />
              <CustomerSelector onChangeCheckbox={onUpdateCustomerCheckbox} onCheckAll={onUpdateCustomerCheckAll} customers={customers.rows} pagination={customers.pagination} checkedIds={selectedCustomerIds} onChangePage={onChangePage} />
            </>)}
      </Section>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <input type="hidden" {...register('status')} />
          <MarginButton type="submit" onClick={() => setValue('status', 'draft')}  disabled={!formState.isValid} variant="muted-outline">下書き保存</MarginButton>
          <MarginButton type="submit" onClick={() => setValue('status', 'submitted')} disabled={!formState.isValid} >確定</MarginButton>
        </div>
        <ApiResults messages={apiMessages} />
      </form>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.user,
  privateMoney: state.mobilePushOperation.private_money,
});

const mapDispatchToProps = dispatch => bindActionCreators({ getMobilePushOperationCustomers, submitMobilePushOperation }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MobilePushOperationNewForm);
